import { render, staticRenderFns } from "./ClassicQuest.vue?vue&type=template&id=1b8ded5f&scoped=true&"
import script from "./ClassicQuest.vue?vue&type=script&lang=js&"
export * from "./ClassicQuest.vue?vue&type=script&lang=js&"
import style0 from "./ClassicQuest.vue?vue&type=style&index=0&id=1b8ded5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8ded5f",
  null
  
)

export default component.exports